const state = {
	sidebarCollapsed: false
};

export default state;
